// La función isEnabled debe recibir los parámetros necesarios
// en lugar de depender de variables globales del componente
export const requisitos = [
    // Subtítulo Etapa I - Solo visible para ÁREA DE MEJORAS
    {
        id: 'etapa_i',
        label: 'ETAPA I',
        isSectionHeader: true,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'nota_solicitud',
        label: 'Nota de solicitud',
        isEnabled: () => true
    },
    {
        id: 'informes_dominio',
        label: 'Informes de dominio',
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE PROYECTOS'
    },
    {
        id: 'designacion_intendente',
        label: 'Designación Intendente',
        isEnabled: (areaResponsable, tipoSubsidio) => tipoSubsidio === 'Subsidio a municipio'
    },
    {
        id: 'anexo_social',
        label: 'Anexo social',
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE PROYECTOS'
    },
    {
        id: 'anexo_tecnico',
        label: 'Anexo técnico',
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE PROYECTOS'
    },
    {
        id: 'computo_y_presupuesto',
        label: 'Cómputo y presupuesto',
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE PROYECTOS'
    },
    {
        id: 'planos_de_proyecto',
        label: 'Proyectos / Planos',
        isEnabled: () => true
    },
    {
        id: 'prefactibilidad_es_de_servicio_s_suscripta_prestataria',
        label: 'Prefactibilidad/es de servicio/s suscripta por la prestataria',
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE PROYECTOS'
    },
    {
        id: 'constancia_de_cbu',
        label: 'Constancia de CBU',
        isEnabled: () => true
    },
    {
        id: 'acta_acuerdo',
        label: 'Acta acuerdo',
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE PROYECTOS'
    },
    {
        id: 'nota_regulacion_dominal',
        label: 'Nota Regulación Dominial',
        etapa: 1,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'nota_certificacion_pago_arquitecto_mmdo',
        label: 'Nota Certificacion Pago Arquitecto/MMdO',
        etapa: 1,
        isEnabled: (areaResponsable, tipoSubsidio) => tipoSubsidio === 'Subsidio a ONG' && areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'convenio_con_certificado',
        label: 'Convenio con certificado',
        etapa: 1,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'pago_a_certif',
        label: 'Pago a certificador',
        etapa: 1,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'informe_final',
        label: 'Informe final',
        etapa: 1,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'listado_beneficiarios',
        label: 'Listado Beneficiarios',
        etapa: 1,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'pago_a_beneficiarios',
        label: 'Pago a Benficiarios',
        etapa: 1,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'anexo_fotografico',
        label: 'Anexo Fotográfico',
        etapa: 1,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    // Subtítulo Etapa II
    {
        id: 'etapa_ii',
        label: 'ETAPA II',
        isSectionHeader: true,
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'nota_solicitud_e2',
        label: 'Nota solicitud E2',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'proyecto_e2',
        label: 'Proyecto E2',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'nota_gastos_operativos',
        label: 'Nota Gastos Operativos',
        etapa: 2,
        isEnabled: (areaResponsable, tipoSubsidio) => tipoSubsidio === 'Subsidio a ONG' && areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'comprobante_microcredito',
        label: 'Comprobante microcrédito o factura',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'informe_rendiciones',
        label: 'Informe Rendiciones',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'ddjj',
        label: 'DDJJ',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'acuerdo_mutuo',
        label: 'Acuerdo Mutuo',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'nomina_beneficiarios',
        label: 'Nomina de Beneficiarios',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    },
    {
        id: 'plan_financiamiento',
        label: 'Plan de Financiamiento',
        etapa: 2,
        isEnabled: (areaResponsable) => areaResponsable === 'ÁREA DE MEJORAS'
    }
];